import { buildUploadUrl } from "@/shared/models/Inspection";
import CloseIcon from "@mui/icons-material/Close";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import {
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Tooltip,
	Typography,
} from "@mui/material";
import { useState } from "react";

type Props = {
	name: string;
	path: string | null;
};

export const SurfaceDefectPhoto = ({ name, path }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const url = buildUploadUrl(path);

	if (!url)
		return (
			<Tooltip title="No photo was taken">
				<ImageNotSupportedOutlinedIcon
					sx={{ fontSize: 16, color: "grey.300", display: "block" }}
				/>
			</Tooltip>
		);

	return (
		<>
			<Tooltip title="See the photo">
				<Box
					component="button"
					type="button"
					onClick={() => setIsOpen(true)}
					sx={{
						p: 0,
						border: "1px solid",
						borderColor: "grey.300",
						borderRadius: "6px",
						overflow: "hidden",
						cursor: "pointer",
						lineHeight: 0,
						backgroundColor: "white",
					}}
				>
					<Box
						component="img"
						src={url}
						alt={name}
						loading="lazy"
						sx={{ width: 26, height: 26, objectFit: "cover", display: "block" }}
					/>
				</Box>
			</Tooltip>

			<Dialog
				open={isOpen}
				onClose={() => setIsOpen(false)}
				maxWidth="md"
				fullWidth
			>
				<DialogTitle
					sx={{
						display: "flex",
						alignItems: "center",
						gap: 1,
						py: 1,
						pr: 1,
					}}
				>
					<Typography sx={{ flex: 1, fontSize: 16, fontWeight: 600 }}>
						{name}
					</Typography>
					<IconButton size="small" onClick={() => setIsOpen(false)}>
						<CloseIcon fontSize="small" />
					</IconButton>
				</DialogTitle>
				<DialogContent sx={{ p: 0, backgroundColor: "grey.900" }}>
					<Box
						component="img"
						src={url}
						alt={name}
						sx={{
							display: "block",
							width: "100%",
							maxHeight: "80vh",
							objectFit: "contain",
						}}
					/>
				</DialogContent>
			</Dialog>
		</>
	);
};
